import { IconArrowBigRight, IconLink, Text } from "@idg-web-platform/pulse";
import css from "./inStoreOrderSummary.module.css";
import { formatAmount, formatDate } from "../utils/formats.ts";
import { OrderSummary } from "./orderSummary.tsx";
import { InStoreLineItem } from "./entities/InStoreLineItem.ts";

export interface InStoreOrderView {
  id: string;
  date: Date;
  total: number;
  storeName?: string;
  storeAddress?: string;
  lineItems: InStoreLineItem[];
}

/**
 * Renders an in-store (STATIONARY) order summary card.
 * These have a simpler layout than online orders - no product images or shipping status.
 * Shows: date, total, store name/address, article count
 */
export function renderInStoreSummary(item: OrderSummary) {
  const storeInfo = item.storeName
    ? `${item.storeName}${item.storeAddress ? `, ${item.storeAddress}` : ""}`
    : undefined;

  return (
    <div key={item.id}>
      <a href={item.detailsLink} className={css.orderSummary}>
        <div className={css.orderSummaryHeader}>
          <div className={css.orderSummaryMeta}>
            <Text sizeStep={-1} removeMargin={true}>
              <span className={css.label}>Einkaufsdatum:</span>{" "}
              <span className={css.value}>{formatDate(item.date)}</span>
            </Text>
            <Text sizeStep={-1} removeMargin={true}>
              <span className={css.label}>Gesamt:</span>{" "}
              <span className={css.valueAccent}>{formatAmount(item.total)}</span>
            </Text>
          </div>
          <div className={css.orderSummaryDetailsLink}>
            <IconLink
              text="Einkauf anzeigen"
              href={item.detailsLink}
              iconComponent={<IconArrowBigRight />}
              iconPosition="right"
            />
          </div>
        </div>

        {storeInfo && (
          <div className={css.storeInfo}>
            <Text sizeStep={-1} removeMargin={true}>
              <span className={css.label}>Store:</span>{" "}
              <span className={css.storeValue}>{storeInfo}</span>
            </Text>
          </div>
        )}

        <div className={css.articleCount}>
          <Text sizeStep={-1} removeMargin={true} fontStyle="bold">
            {item.articleCount} {"Artikel"}
          </Text>
        </div>
      </a>
    </div>
  );
}
